import Button from "devextreme-react/button";
import React, { FC } from "react";
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import { Routes } from "../../AppRoutes";
import { ObjectUtils } from "../../modules/utils";
import { Apps } from "../../pages/home";
import { useSelector } from "../../store/store";
import { Image } from "../image";
import { useNotfiy } from "../../pages/notify/hooks/use-notify";
// import { useDocumentsFolders, usePublishDocumentsFolders } from "../../pages/document/hooks";

export const Header: FC = () => {
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const routeMatch = useRouteMatch();
  const currentAppActive = routeMatch.path !== "/" && Apps.find((v) => routeMatch.path.indexOf(v.path) === 0);
  const avatar = ObjectUtils.getIn(user?.current, "idTokenClaims.avatar");
  const name = ObjectUtils.getIn(user?.current, "idTokenClaims.name");
  const email = ObjectUtils.getIn(user?.current, "idTokenClaims.preferred_username");
  const buttonClassName = "my-custom-button";
  const currentUrl = window.location.href.search("document");
  const { countNotifyToMeData, firstItem } = useNotfiy();
  // useDocumentsFolders();
  // usePublishDocumentsFolders();

  return (
    <header className="Header">
      <div className="procedure__container d-flex" style={{ margin: 0 }}>
        <div className="arrow-left">
          <div className="arrow-top"></div>
          <NavLink to={Routes.home.path} className="icon_back">
            <Button className={buttonClassName} icon="home" stylingMode="text" type="normal" />
          </NavLink>
        </div>
        <NavLink className="logo" to={Routes.home.path}>
          <img src="/assets/images/logo-dark-bg.png" alt="Viags Eoffice" />
        </NavLink>
        <div className="title">
          <h1>VĂN PHÒNG ĐIỆN TỬ</h1>
          <h2>VIAGS EOFFICE</h2>
        </div>
      </div>

      {currentAppActive ? (
        <div className="AppActive">
          {currentAppActive.icon}
          {currentAppActive.name}
        </div>
      ) : null}

      <div className="userProfile">
        {currentUrl > 0 && (
          <div className="header__navbar-item header__navbar-item--has-notify">
            <div className="header__navbar-item-link">
              <div className="Alert__bell">{countNotifyToMeData}</div>
              <div className="bell">
                <Button
                  icon="bell"
                  stylingMode="text"
                  type="normal"
                  onClick={() => history.push(`/document-notify?notifyId=${firstItem?.id}`)}
                />
              </div>
            </div>
          </div>
        )}

        <div className="info" onClick={() => history.push(Routes.account.path)}>
          <div className="name">{`${name}`}</div>
          <div className="email">{email}</div>
        </div>
        <Image src={avatar} type="avatar" />
      </div>
    </header>
  );
};
